import Link from './Link';
export const models = {
  Link
};
flarum.reg.add('fof-links', 'common/models', null);